import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

interface PendingActionsCardProps {
  count: number;
  loading: boolean;
  onClick: () => void;
}

export const PendingActionsCard = ({ count, loading, onClick }: PendingActionsCardProps) => {
  if (loading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between space-y-0 pb-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-4" />
          </div>
          <div className="space-y-1">
            <Skeleton className="h-8 w-12" />
            <Skeleton className="h-3 w-32" />
          </div>
        </CardContent>
      </Card>
    );
  }

  const hasActions = count > 0;

  return (
    <Card 
      className={`cursor-pointer transition-all hover:shadow-md hover:border-primary/50 ${
        hasActions ? 'border-warning/30 bg-warning/5' : ''
      }`}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between space-y-0 pb-2">
          <p className="text-sm font-medium text-muted-foreground">Pending Actions</p>
          {hasActions ? (
            <AlertCircle className="h-4 w-4 text-warning" />
          ) : (
            <CheckCircle className="h-4 w-4 text-success" />
          )}
        </div>
        <div className="space-y-1">
          <p className="text-2xl font-bold">{count}</p>
          <p className={`text-xs ${hasActions ? 'text-warning' : 'text-success'}`}>
            {hasActions 
              ? `${count} item${count > 1 ? 's' : ''} need${count === 1 ? 's' : ''} attention`
              : "You're all caught up!"
            }
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
